import { render, staticRenderFns } from "./orient.vue?vue&type=template&id=33648622&scoped=true"
import script from "./orient.vue?vue&type=script&lang=js"
export * from "./orient.vue?vue&type=script&lang=js"
import style0 from "./orient.vue?vue&type=style&index=0&id=33648622&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33648622",
  null
  
)

export default component.exports